import request from 'sb-request'
import { modifyProduct } from 'common/helpers/modifiers/modifyResponse'


const fetchFragranceData = ({ productId }) =>
  request.get(`rest/product/${productId}`, {
    modifyResult: modifyProduct,
  })

const fetchFragranceOfTheMonthData = (params) =>
  request.get('rest/engine/perfumeofmonth', params)


export default {
  fetchFragranceData,
  fetchFragranceOfTheMonthData,
}
